import { ChildrenItemIconFields } from '../../../types/Admin/ItemIconTypes';
import { ItemIconSettings } from '../../../types/Admin/ItemIconTypes';
import { defaultItemIconSettings } from '../../mediaBackground';

export const parseChildrenIconSettings = (
  source?: Partial<ChildrenItemIconFields> | null
): ItemIconSettings => ({
  iconUrl:
    source?.childrenIconUrl && source.childrenIconUrl !== '' ? source.childrenIconUrl : null,
  iconFitMode: source?.childrenIconFitMode ?? defaultItemIconSettings.iconFitMode,
  iconScale: source?.childrenIconScale ?? defaultItemIconSettings.iconScale,
  iconPositionX: source?.childrenIconPositionX ?? defaultItemIconSettings.iconPositionX,
  iconPositionY: source?.childrenIconPositionY ?? defaultItemIconSettings.iconPositionY
});
